<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent max-width="600px">
      <v-form ref="form" @submit.prevent="handleSubmit">
        <v-card :loading="loading">
          <v-card-title>
            <span class="headline">{{$t('modal.updatePassword.title')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert
                    v-if="error"
                    border="left"
                    colored-border
                    type="error"
                    elevation="2"
                  >{{error}}</v-alert>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="password"
                    label="Password"
                    type="password"
                    :rules="[rules.required, ...passwordRules]"
                    validate-on-blur
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    label="Confirm"
                    type="password"
                    :rules="[rules.required, rules.confirmPassword] "
                    validate-on-blur
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onCancel">{{$t('label.cancel')}}</v-btn>
            <v-btn color="blue darken-1" type="submit">{{$t('label.save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import {passwordRules} from "../utils/userUtils"
export default {
  name: "UpdatePassword",
  data() {
    return {
      password: "",
      passwordRules,
      rules: {
        required: value => !!value || "Required",
        confirmPassword: value =>
          value === this.password || "Passwords do not match"
      }
    };
  },
  props: {
    error: {},
    loading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$emit("onConfirmed", this.password);
    },
    onCancel() {
      this.$emit("onCancelled");
    }
  },
  created: function() {}
}
</script>